import {
    FETCH_LOGIN_REQUEST,
    FETCH_TODO_SUCCESS,
    FETCH_TODO_FAILURE,
    FETCH_SIGNUP_REQUEST,
    SET_ACCOUNT_VALUE,
    SET_ACCOUNT_REQUEST
} from "./actionTypes";

import { toAccountAction, todoAccountState } from "./types";

const initialState: todoAccountState = {
    pending: false,
    account: [],
    error: null,
    message:"",
    result: null
};

const toAccountReducer = (state = initialState, action: toAccountAction) => {
    switch (action.type) {
        case FETCH_SIGNUP_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case SET_ACCOUNT_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case FETCH_LOGIN_REQUEST:
            return {
                ...state,
                pending: true
            }
        case FETCH_TODO_SUCCESS:
            return {
                ...state,
                pending: false,
                account: action.payload.account,
                error: null,
                message:"Login success"
            };
        case FETCH_TODO_FAILURE:
            return {
                ...state,
                message:"Email or Password is incorrect, please try again",
                error: action.payload.error,
            };
        case SET_ACCOUNT_VALUE:
            return {
                ...state,
                pending: false,
                account: action.payload.account,
                result: action.payload.result,
                error: null,
                message:"Get user success"
            }
        default:
            return {
                ...state,
            };
    }
};

export default toAccountReducer;
